import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import apiDocsPlugin from '@backstage/plugin-api-docs/alpha';
import techdocsPlugin from '@backstage/plugin-techdocs/alpha';
// Renders ```mermaid fenced blocks in TechDocs as diagrams. Stock TechDocs shows
// them as raw code; this addon (new frontend system module) does client-side
// rendering in the reader. See docs/leaderboards/* in skullgirls-server.
import { techDocsMermaidAddonModule } from 'backstage-plugin-techdocs-addon-mermaid/alpha';
import { navModule } from './modules/nav';
import { auth0Module } from './auth/auth0';

export default createApp({
  features: [
    catalogPlugin,
    apiDocsPlugin,
    techdocsPlugin,
    techDocsMermaidAddonModule,
    navModule,
    auth0Module,
  ],
});
